module.exports = __webpack_public_path__ + "static/img/newanli-08.99f3d708.jpg";